export enum LocalStorageEnum {
  AUTH_TOKEN = 'auth_token',
  MEMBERSHIPS = 'memberships',
  FILTER_CLASSES_AREA = 'filter_classes_area',

  PUBLIC_EVENT_ID = 'public_event_id',
  PUBLIC_EVENT_DATE = 'public_event_date',

  ANNOUNCEMENTS = 'announcements',
  ANNOUNCEMENTS_DATE_TIME_REQUEST = 'announcements_date_time_request',
}
